import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';
import { SaveNotificationSettingsParams } from '@/api/apiNotify'

export interface INotification {
    id: number;
    title: string;
    text: string;
    date: string;
    files: any[];
}

interface INotifications {
    list: INotification[];
    totalRows: number;
}

export type SwitchesNames = Exclude<keyof SaveNotificationSettingsParams, 'additional_emails' | 'period'>

interface INotifyState {
    isSettingsLoaded: boolean;
    isNotificationsLoaded: boolean;
    settings: SaveNotificationSettingsParams;
    notifications: INotifications;
    addEmail: (email: string) => void;
    removeEmail: (emailToRemove: string) => void;
    toggleSwitch: (switchName: SwitchesNames) => void;
    setNotificationSettings: (settingsData: SaveNotificationSettingsParams) => void;
    setNotifications: (data: INotification[]) => void;
}

export const useNotifyStore = create(
    devtools(
        immer<INotifyState>((set, get) => ({
            isSettingsLoaded: false,
            isNotificationsLoaded: false,
            settings: {
                additional_emails: [],
                send_notification: false,
                send_new_lics: false,
                send_exp_lics: false,
                period: 1,
            },
            notifications: {
                list: [],
                totalRows: 0,
            },
            setNotificationSettings: (settingsData) => {
                set((draft) => {
                    draft.isSettingsLoaded = true
                    draft.settings.additional_emails = settingsData.additional_emails ?? draft.settings.additional_emails;
                    draft.settings.period = settingsData.period ?? draft.settings.period;

                    draft.settings.send_notification =
                        settingsData.send_notification ?? draft.settings.send_notification;

                    draft.settings.send_new_lics =
                        settingsData.send_new_lics ?? draft.settings.send_new_lics;

                    draft.settings.send_exp_lics =
                        settingsData.send_exp_lics ?? draft.settings.send_exp_lics;
                }, false);
            },

            setNotifications: (data) => {
                set((draft) => {
                    draft.isNotificationsLoaded = true
                    draft.notifications.list = data;
                    draft.notifications.totalRows = data.length;
                }, false);
            },

            addEmail: (email) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email) || get().settings.additional_emails.includes(email)) {
                    console.warn("Попытка добавить невалидный или дублирующийся email:", email);
                    return;
                }
                set((draft) => {
                    draft.settings.additional_emails.push(email);
                });
            },

            removeEmail: (emailToRemove) => {
                set((draft) => {
                    draft.settings.additional_emails = draft.settings.additional_emails.filter(
                        (email) => email !== emailToRemove
                    );
                });
            },

            toggleSwitch: (switchName) => {
                set((draft) => {
                    draft.settings[switchName] = !draft.settings[switchName];
                });
            },
        })),
        {
            name: 'NotifyStore',
        }
    )
);
